/*
  Project: Kelsey Media - Classified Listing Brand
  Author: Xfive
 */

import ListingFilters from "./modules/listingFilters";
import Slider from "./modules/slider";
import Listing from "./modules/listing";
import Users from "./modules/users";
import ItemsExport from "./modules/itemsExport";
import Profile from "./modules/profile";
import Directory from "./modules/directory";
import CharactersLimitCounter from "./modules/charactersLimitCounter";
import MultiSelect from "./modules/multiSelect";

new ListingFilters();
new Slider();
new Listing();
new Users();
new ItemsExport();
new Profile();
new Directory();
new CharactersLimitCounter();
new MultiSelect();
